import RowInfo from "./RowInfo";
import RowActions from "./RowActions";
import RowButtons from "./RowButtons";
import { AdminListCard, AdminActions } from "../../../../SharedComponents/ListView";

export default function InventoryListRow({ inventory }) {
  const editedInventory = { ...inventory, isTest: false };

  return (
    <AdminListCard
      tag={editedInventory.tag}
      footer={
        <AdminActions className="justify-content-start">
          <RowActions inventory={editedInventory} />
        </AdminActions>
      }
    >
      <RowInfo inventory={editedInventory} />
      <AdminActions>
        <RowButtons inventory={editedInventory} />
      </AdminActions>
    </AdminListCard>
  );
}
